export interface ITier {
    title: string;
    subtitle: string;
    level: number;
    priceMonthly: number | null;
    priceYearly: number | null;
    priceMonthlyDiscounted: number | null;
    priceYearlyDiscountPercentage: number | null;
    priceAdditionalTenant: number | null;
    customizationPercentage: number | null;
    priceCustomizationRate: number | null;
    tenantsIncluded: number | null;
    demoTenantsIncluded: number | null;
    bringYourOwnDomain: boolean;
    sapAriba: boolean;
    cloudbarSubdomain: boolean;
    pwaOfflineCapabilities: boolean;
    languages: number | null;
    contextualAITranslations: boolean;
    pageCMS: boolean;
    eCommerce: boolean;
    approvalSystem: boolean;
    themeBranding: boolean;
    sendGridIntegration: boolean;
    chat: boolean;
    pushNotifications: boolean | null;
    twoFAMail: boolean;
    twoFAAuthenticator: boolean;
    aiTextGeneration: boolean;
    aiWebToPrintAssistant: boolean;
    customSendGridTemplates: boolean;
    sso: boolean;
    apiRestAPI: boolean;
    setupTime: string | null;
    integrations: string[];
    showVat?: boolean;
}

export const tier1: ITier = {
    title: 'Single Tenant',
    subtitle: 'Starter Plan',
    level: 1,
    priceMonthly: 380,
    priceYearly: 4100,
    priceMonthlyDiscounted: 342,
    priceYearlyDiscountPercentage: 10,
    priceAdditionalTenant: null,
    customizationPercentage: 0,
    priceCustomizationRate: null,
    tenantsIncluded: 1,
    demoTenantsIncluded: 0,
    bringYourOwnDomain: false,
    sapAriba: true,
    cloudbarSubdomain: true,
    pwaOfflineCapabilities: true,
    languages: 6,
    contextualAITranslations: true,
    pageCMS: true,
    eCommerce: true,
    approvalSystem: true,
    themeBranding: true,
    sendGridIntegration: true,
    chat: false,
    pushNotifications: true,
    twoFAMail: true,
    twoFAAuthenticator: true,
    aiTextGeneration: true,
    aiWebToPrintAssistant: false,
    customSendGridTemplates: false,
    sso: true,
    apiRestAPI: true,
    setupTime: 'Instant',
    integrations: ['Printformer', 'Pageflex Server'],
    showVat: true,
};

export const tier2: ITier = {
    title: 'Multi-Tenant',
    subtitle: 'Growing Business Plan',
    level: 2,
    priceMonthly: 1450,
    priceYearly: 15660,
    priceMonthlyDiscounted: 1300,
    priceYearlyDiscountPercentage: 10,
    priceAdditionalTenant: 200,
    customizationPercentage: 10,
    priceCustomizationRate: 140,
    tenantsIncluded: 2,
    demoTenantsIncluded: 3,
    bringYourOwnDomain: true,
    sapAriba: true,
    cloudbarSubdomain: true,
    pwaOfflineCapabilities: true,
    languages: null, // assuming unlimited as non-numeric
    contextualAITranslations: true,
    pageCMS: true,
    eCommerce: true,
    approvalSystem: true,
    themeBranding: true,
    sendGridIntegration: true,
    chat: true,
    pushNotifications: true,
    twoFAMail: true,
    twoFAAuthenticator: true,
    aiTextGeneration: true,
    aiWebToPrintAssistant: true,
    customSendGridTemplates: true,
    sso: true,
    apiRestAPI: true,
    setupTime: 'Same Day',
    integrations: ['Printformer', 'Pageflex Server'],
    showVat: true,
};

export const tier3: ITier = {
    title: 'Customized',
    subtitle: 'Enterprise Plan',
    level: 3,
    priceMonthlyDiscounted: null,
    priceMonthly: null, // assuming request a quote
    priceYearly: null, // assuming request a quote
    priceYearlyDiscountPercentage: null,
    priceAdditionalTenant: null,
    customizationPercentage: 40, // assuming unlimited as non-numeric
    priceCustomizationRate: null, // assuming it varies
    tenantsIncluded: null, // assuming it varies
    demoTenantsIncluded: null, // assuming it varies
    bringYourOwnDomain: true,
    sapAriba: true,
    cloudbarSubdomain: true,
    pwaOfflineCapabilities: true,
    languages: null, // assuming unlimited as non-numeric
    contextualAITranslations: true,
    pageCMS: true,
    eCommerce: true,
    approvalSystem: true,
    themeBranding: true,
    sendGridIntegration: true,
    chat: true,
    pushNotifications: null, // not specified
    twoFAMail: true,
    twoFAAuthenticator: true,
    aiTextGeneration: true,
    aiWebToPrintAssistant: true,
    customSendGridTemplates: true,
    sso: true,
    apiRestAPI: true,
    setupTime: null, // not specified
    integrations: ['Printess', 'Pageflex Server', 'Intomedia IPC', 'SAP OCI'],
    showVat: false,
};

export const tiers = [tier1, tier2, tier3];
